(function () {
  'use strict';

  var WHATSAPP_LINK = 'a[href*="api.whatsapp.com/send"], a[href*="wa.me/"]';
  var SEPARATOR = '—————————————';
  var CLICK_IDS = ['gclid', 'fbclid', 'ttclid', 'ScCid'];
  var COOKIE_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].concat(CLICK_IDS);

  function isTracked(key) {
    return key.indexOf('utm_') === 0 || CLICK_IDS.indexOf(key) > -1;
  }

  function getCookie(key) {
    var prefix = 'zf_' + key + '=';
    var parts = document.cookie.split('; ');
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].indexOf(prefix) === 0) {
        try { return decodeURIComponent(parts[i].substring(prefix.length)); } catch (e) { return ''; }
      }
    }
    return '';
  }

  // The current URL wins as a whole set; cookies are used only when the URL has no campaign params.
  function getAttribution() {
    var params = new URLSearchParams(location.search);
    var data = {};
    var fromUrl = false;
    params.forEach(function (value, key) {
      if (value && isTracked(key)) {
        data[key] = value;
        fromUrl = true;
      }
    });
    if (!fromUrl) {
      COOKIE_KEYS.forEach(function (key) {
        var value = getCookie(key);
        if (value) data[key] = value;
      });
    }
    return data;
  }

  // Puts the lead data above any prefilled message so marketing can read it in WhatsApp.
  function withLeadHeader(href, data) {
    var url;
    try { url = new URL(href, location.href); } catch (e) { return href; }
    var lines = Object.keys(data).map(function (key) {
      return key + ': ' + data[key];
    });
    lines.push('page: ' + location.pathname, SEPARATOR);
    var text = url.searchParams.get('text');
    if (text) lines.push(text);
    url.searchParams.delete('text');
    // encodeURIComponent, not searchParams.set: WhatsApp shows the "+" it uses for spaces literally.
    url.search = (url.search ? url.search + '&' : '') + 'text=' + encodeURIComponent(lines.join('\n'));
    return url.href;
  }

  function decorateWhatsAppLinks() {
    var data = getAttribution();
    document.querySelectorAll(WHATSAPP_LINK).forEach(function (link) {
      link.href = withLeadHeader(link.href, data);
    });
  }

  // For WhatsApp URLs built in JS (e.g. opened with window.open after a form submit).
  window.withWhatsAppLeadHeader = function (href) {
    return withLeadHeader(href, getAttribution());
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', decorateWhatsAppLinks);
  else decorateWhatsAppLinks();
})();
